let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("goutI")).then(() => parcelRequire('8NAUH'));